<div class="status-chip" matTooltip="Episodic Measure" *ngIf="index">
  <mat-icon>library_books</mat-icon>
  <div class="episode-index ml-1">EP {{ index }}</div>
</div>
